import React from "react";
import ContactForm from "../components/ContactForm";
import { motion } from "framer-motion";
import "../App.css";
import Text from "../components/Text";
import "../csscontainer/Form.css";
import email from "../assets/images/email_icon.png";
import contactus from "../assets/images/contact_us.png";
import { TEXT } from "../utility/constants";
import Footer from "../components/Footer";

// Adjust the path as necessary
function ContactUs() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="home-wrapper">
        <div className="row-containers">
          <img
            style={{ height: "600px", width: "600px", margin: "auto" }}
            src={contactus} // Your IT service image
            alt="Diverse IT Service Projects and Solutions"
            className="responsive-service-image"
          />

          <div className="form-box">
            <ContactForm />
          </div>
        </div>

        <div className="form-content">
          <h1>
            {" "}
            <Text color="white" size="26px" weight="bold" align="start">
              <h1>Contact Us</h1>
            </Text>
          </h1>
          <Text color="white" size="24px" align="start">
            {TEXT.contactDesc}
          </Text>
          {/* <div className="contacts-detail">
              <img src={phone} alt="Visual" className="info-icon" />
              <Text color="white" size="20px" weight="bold" align="start">
                {TEXT.PHONE_NUM}
              </Text>
            </div>

            <div className="contacts-detail">
              <img src={mobile} alt="Visual" className="info-icon" />
              <Text color="white" size="20px" weight="bold" align="start">
                {TEXT.MOBILE_NUM}
              </Text>
            </div> */}

          <div className="contacts-detail">
            <img src={email} alt="Visual" className="info-icon" />
            <Text color="white" size="20px" weight="bold" align="start">
              {TEXT.EMAIL}
            </Text>
          </div>
        </div>

        <Footer />
      </div>
    </motion.div>
  );
}

export default ContactUs;
